import React, { useCallback, useEffect, useState } from "react";
import {
  Row,
  Col,
  Form,
  Button,
  Modal,
} from "react-bootstrap";
import { Search } from "lucide-react";
import { Link } from "react-router-dom";
import "../../../../assets/css/my-Profile.css";
import Breadcrumbdasbord from "../../component/Breadcrumbdasbord";
import Sidebarmenu from "../../component/SidebarNavigation";
import toast from "react-hot-toast";
import {  getOrders, sendOrderWhatsapp } from "../../service/OrderHistory.service";
import DataTable from "react-data-table-component";
import { Toaster } from "react-hot-toast";
import { generateInvoicePdf } from "../../../../Component/Common/service/pdf.service";

function MyOrder() {
  // =========================================================
  // ORDERS
  // =========================================================
  const [orders, setOrders] = useState([]);
  const [search, setSearch] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [invoiceLoading, setInvoiceLoading] = useState(null);
  // =========================================================
  // WHATSAPP
  // =========================================================
  const [showWhatsappModal, setShowWhatsappModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [mobileNumber, setMobileNumber] = useState("");
  const [whatsappLoading, setWhatsappLoading] = useState(false);

  // =========================================================
  // LOAD ORDERS
  // =========================================================
  const loadOrders = useCallback(async () => {
    try {
      setLoading(true);

      const response = await getOrders({
        search: search.trim(),
        from_date: fromDate,
        to_date: toDate,
      });

      const apiData = response?.data;
      let orderData = [];

      if (Array.isArray(apiData)) {
        orderData = apiData;
      } else if (Array.isArray(apiData?.data)) {
        orderData = apiData.data;
      } else if (Array.isArray(response)) {
        orderData = response;
      }

      setOrders(orderData);
    } catch (error) {
      console.error("Orders Error:", error);
      setOrders([]);
      toast.error(error?.response?.data?.message || "Failed to load orders");
    } finally {
      setLoading(false);
    }
  }, [search, fromDate, toDate]);

  useEffect(() => {
    loadOrders();
  }, [loadOrders]);

  // =========================================================
  // SEARCH
  // =========================================================
  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  // =========================================================
  // FROM DATE
  // =========================================================
  const handleFromDate = (e) => {
    const value = e.target.value;

    setFromDate(value);

    if (toDate && value > toDate) {
      setToDate("");
    }
  };

  // =========================================================
  // TO DATE
  // =========================================================
  const handleToDate = (e) => {
    const value = e.target.value;

    if (fromDate && value < fromDate) {
      alert(
        "To Date cannot be before From Date"
      );
      return;
    }

    setToDate(value);
  };

  // =========================================================
  // CLEAR
  // =========================================================
  const handleClear = async () => {
    setSearch("");
    setFromDate("");
    setToDate("");

    try {
      setLoading(true);

      const response = await getOrders({
        search: "",
        from_date: "",
        to_date: "",
      });

      const apiData = response?.data;

      let orderData = [];

      if (Array.isArray(apiData)) {
        orderData = apiData;
      } else if (Array.isArray(apiData?.data)) {
        orderData = apiData.data;
      } else if (Array.isArray(response)) {
        orderData = response;
      }

      setOrders(orderData);
    } catch (error) {
      console.error("Orders Error:", error);
      setOrders([]);
    } finally {
      setLoading(false);
    }
  };


  // =========================================================
  // GET CUSTOMER MOBILE
  // =========================================================
  const getCustomerMobile = (order) => {
    return (
      order?.customer_mobile ||
      order?.mobile_no ||
      order?.mobile ||
      order?.phone ||
      order?.customer_phone ||
      order?.customer?.mobile ||
      order?.customer?.mobile_no ||
      order?.customer?.phone ||
      ""
    );
  };

  // =========================================================
  // GET CUSTOMER NAME
  // =========================================================
  const getCustomerName = (order) => {
    return (
      order?.customer_name ||
      order?.customer?.name ||
      order?.customer?.customer_name ||
      "-"
    );
  };

  // =========================================================
  // OPEN WHATSAPP MODAL
  // =========================================================
const handleWhatsappClick = (row) => {
  console.log(
    "Selected WhatsApp Order:",
    row
  );

  if (!row?.order_token) {
    toast.error(
      "Order token not found"
    );
    return;
  }

  setSelectedOrder(row);

  const mobile =
    getCustomerMobile(row);

  let cleanMobile = String(
    mobile || ""
  ).replace(/\D/g, "");

  if (
    cleanMobile.startsWith("91") &&
    cleanMobile.length === 12
  ) {
    cleanMobile =
      cleanMobile.substring(2);
  }

  setMobileNumber(cleanMobile);
  setShowWhatsappModal(true);
};


  // =========================================================
  // CLOSE WHATSAPP MODAL
  // =========================================================
  const handleCloseWhatsappModal = () => {
    if (whatsappLoading) {
      return;
    }
    setShowWhatsappModal(false);
    setSelectedOrder(null);
    setMobileNumber("");
  };

  // =========================================================
  // SEND WHATSAPP
  // =========================================================
const handleSendWhatsapp = async () => {
  if (!selectedOrder) {
    toast.error("Order not selected");
    return;
  }
  const orderToken =
    selectedOrder?.order_token ||
    selectedOrder?.token ||
    "";
  if (!orderToken) {
    toast.error("Order token is missing");
    return;
  }
  let cleanMobile = String(mobileNumber || "").replace(/\D/g, "");
  if (cleanMobile.startsWith("91") && cleanMobile.length === 12) {
    cleanMobile = cleanMobile.substring(2);
  }

  if (cleanMobile.length !== 10) {
    toast.error("Please enter valid 10 digit mobile number");
    return;
  }

  try {
    setWhatsappLoading(true);
    const message = `Hello ${getCustomerName(selectedOrder)},
    Order Details:
    Order No: ${selectedOrder?.order_no || "-"}
    Order Status: ${selectedOrder?.order_status || "-"}
    Order Value: ₹${Number(
    selectedOrder?.grand_total || 0
    ).toLocaleString("en-IN")}

   Thank you.`;
    const payload = {
      order: {
        ...selectedOrder,
        order_token: orderToken,
      },
      mobile: cleanMobile,
      message: message,
    };
    await sendOrderWhatsapp(payload);
    toast.success("WhatsApp message sent successfully!");
    setShowWhatsappModal(false);
    setSelectedOrder(null);
    setMobileNumber("");

  } catch (error) {
    console.error("WHATSAPP ERROR:", error);
    toast.error(
      error?.response?.data?.message ||
      error?.message ||
      "Failed to send WhatsApp message"
    );

  } finally {
    setWhatsappLoading(false);
  }
};
  // =========================================================
  // INVOICE
  // =========================================================
const handleInvoice = async (row) => {
  if (!row?.invoice_url) {
    toast.error("Invoice not available");
    return;
  }

  try {
    setInvoiceLoading(row.invoice_url);

    const response = await generateInvoicePdf(
      row.invoice_url,
      row.invoice_no
    );

    const base64 = response.pdf_base64;

    const cleanBase64 = base64.replace(
      /^data:application\/pdf;base64,/,
      ""
    );

    const byteCharacters = window.atob(cleanBase64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] =
        byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    const blob = new Blob([byteArray], {
      type:
        response.mime_type ||
        "application/pdf",
    });

    const downloadUrl =
      window.URL.createObjectURL(blob);

    const link = document.createElement("a");

    link.href = downloadUrl;
    link.download =
      response.file_name ||
      `${row.invoice_no}.pdf`;

    document.body.appendChild(link);
    link.click();
    link.remove();

    window.URL.revokeObjectURL(downloadUrl);

    toast.success(
      "Invoice downloaded successfully"
    );
  } catch (error) {
    console.error("Invoice Download Error:", error);

    toast.error(
      error?.message || "Failed to download invoice"
    );
  } finally {
     setInvoiceLoading(null);
  }
};
  // =========================================================
  // TABLE COLUMNS
  // =========================================================
const columns = [


  {
    name: "Order No.",
    cell: (row) => (
      <Link
        to={`/account/orders/${encodeURIComponent(row?.order_no || "")}`}
        className="text-decoration-none"
      >
        {row?.order_no || "-"}
      </Link>
    ),
    width: "10%",
    sortable: true,
  },

  {
    name: "Account Name",
    selector: (row) => getCustomerName(row),
    width: "24%",
    sortable: true,
  },

  {
    name: "Order Date",
    selector: (row) =>
      row?.created_at
        ? new Date(row.created_at).toLocaleDateString("en-GB")
        : "-",
    width: "10%",
    sortable: true,
  },

  {
    name: "Order Type",
    cell: (row) =>
      row?.order_type === "fresh" ? (
        <span className="badge bg-success">New Order</span>
      ) : (
        <span className="badge bg-primary">Pre Order</span>
      ),
    width: "10%",  
    center: true,
  },

  {
    name: "Order Status",
    cell: (row) =>
      row?.order_status === "shipped" ? (
        <span className="badge bg-primary">Shipped</span>
      ) : (
        <span className="badge bg-warning text-dark">Pending</span>
      ),
    width: "10%",      
    center: true,
  },

  {
    name: "Order Value",
    selector: (row) =>
      `₹${Number(row?.grand_total || 0).toLocaleString("en-IN")}`,
    width: "10%",
    sortable: true,
    right: true,
  },

{
  name: "Invoice Details",
  cell: (row) => {
    const hasInvoice = Boolean(row?.invoice_url);

    const isInvoiceLoading =
      hasInvoice &&
      invoiceLoading === row?.invoice_url;

    return (
      <div className="invoice-wrapper">
        <span className="invoice-number">
          {row?.invoice_no || "No Available"}
        </span>

        <button
          type="button"
          className="invoice-pdf-btn"
          onClick={() => handleInvoice(row)}
          title={
            hasInvoice
              ? "Download Invoice"
              : "Invoice not available"
          }
          disabled={!hasInvoice || isInvoiceLoading}
        >
          {isInvoiceLoading ? (
            <span className="invoice-spinner" />
          ) : (
            <i className="bi bi-file-earmark-pdf-fill"></i>
          )}
        </button>
      </div>
    );
  },
  center: true,
  width: "16%",
},

{
  name: "Self Action",
  cell: (row) => (
    <div className="communication-icons">
      <button
        type="button"
        className="grid-icon whatsapp-icon"
        onClick={() => handleWhatsappClick(row)}
        title="Send WhatsApp"
      >
        <i className="bi bi-whatsapp"></i>
      </button>

      <button
  type="button"
  className="grid-icon email-icon"
  disabled={true}
  title="Send Email"
>
  <i className="bi bi-envelope-fill"></i>
</button>
    </div>
  ),
  center: true,
  width: "10%",
},
  // Action
  // {
  //   name: "Action",
  //   cell: (row) => (
  //     <Dropdown align="end">
  //       <Dropdown.Toggle
  //         as="button"
  //         type="button"
  //         className="download-btn-order border-0"
  //       >
  //         <i className="bi bi-send-arrow-down"></i>
  //       </Dropdown.Toggle>

  //       <Dropdown.Menu className="action-dropdown-order">
  //         <Dropdown.Item onClick={() => handleWhatsappClick(row)}>
  //           <i className="bi bi-whatsapp text-success me-1"></i>
  //           <span className="text-success">WhatsApp</span>
  //         </Dropdown.Item>

  //         <Dropdown.Item
  //           as={Link}
  //           to={`/orders/${encodeURIComponent(row?.order_no || "")}`}
  //         >
  //           <i className="bi bi-eye text-warning me-1"></i>
  //           <span className="text-warning">View</span>
  //         </Dropdown.Item>
  //       </Dropdown.Menu>
  //     </Dropdown>
  //   ),
  //   center: true,
  //   width: "100px",
  // },
];

  // =========================================================
  // FILTER ORDERS
  // =========================================================
  const filteredOrders =
    orders.filter((item) => {
      // -----------------------------------------------------
      // SEARCH
      // -----------------------------------------------------
      const keyword =
        search.trim().toLowerCase();

      const orderNo = String(
        item?.order_no || ""
      ).toLowerCase();

      const customerName =
        String(
          getCustomerName(item)
        ).toLowerCase();

      const orderStatus =
        String(
          item?.order_status ||
            item?.status ||
            ""
        ).toLowerCase();

      const matchesSearch =
        !keyword ||
        orderNo.includes(keyword) ||
        customerName.includes(keyword) ||
        orderStatus.includes(keyword);

      // -----------------------------------------------------
      // NO DATE
      // -----------------------------------------------------
      if (!item?.created_at) {
        return matchesSearch;
      }

      const orderDate =
        new Date(item.created_at);

      if (isNaN(orderDate.getTime())) {
        return matchesSearch;
      }

      // -----------------------------------------------------
      // FROM DATE
      // -----------------------------------------------------
      let matchesFromDate = true;

      if (fromDate) {
        const from = new Date(
          `${fromDate}T00:00:00`
        );

        matchesFromDate =
          orderDate >= from;
      }

      // -----------------------------------------------------
      // TO DATE
      // -----------------------------------------------------
      let matchesToDate = true;

      if (toDate) {
        const to = new Date(
          `${toDate}T23:59:59.999`
        );

        matchesToDate =
          orderDate <= to;
      }

      return (
        matchesSearch &&
        matchesFromDate &&
        matchesToDate
      );
    });

  // =========================================================
  // DATA TABLE STYLE
  // =========================================================
 const customStyles = {
  headRow: {
    style: {
      minHeight: "36px",
      height: "36px",
      backgroundColor: "#f8f9fa",
      borderTop: "1px solid #dee2e6",
      borderBottom: "1px solid #dee2e6",
    },
  },

  headCells: {
    style: {
      fontSize: "13px",
      fontWeight: "600",
      color: "#495057",
      padding: "5px 8px",
      borderRight: "1px solid #dee2e6",
    },
  },

  rows: {
    style: {
      minHeight: "38px",
      height: "30px",
      fontSize: "13px",
    },
  },

  cells: {
    style: {
      fontSize: "13px",
      padding: "3px 8px",
    },
  },
};
  // =========================================================
  // RETURN
  // =========================================================
  return (

    <> 
     <Toaster
      position="top-right"
      reverseOrder={false}
      toastOptions={{
        duration: 3000,
      }}
    />

    <section className="profile-section">
      <div className="container-fluid">
        <Row>

          {/* =================================================
              SIDEBAR
          ================================================= */}
          
            <Sidebarmenu />

          {/* =================================================
              MAIN
          ================================================= */}
          <Col lg={10} md={9}>

            <Breadcrumbdasbord
              title="My Orders"
              items={[
                {
                  label: "My Orders",
                },
              ]}
            />

            <div className="customer-wrapper">

              {/* =================================================
                  HEADER
              ================================================= */}
              <div className="customer-header">

                {/* LEFT: SEARCH + FILTERS */}
                <div className="header-left">

                  {/* SEARCH */}
                  <div className="search-box">
                    <Search size={16} className="search-icon" />

                    <Form.Control
                      type="text"
                      placeholder="Search orders..."
                      value={search}
                      onChange={handleSearch}
                      className="border-0 shadow-none"
                    />
                  </div>

                  {/* FROM DATE */}
                  <div className="date-filter">
                    <label htmlFor="from-date">From</label>

                    <Form.Control
                      id="from-date"
                      type="date"
                      value={fromDate}
                      onChange={handleFromDate}
                      max={toDate || undefined}
                    />
                  </div>

                  {/* TO DATE */}
                  <div className="date-filter">
                    <label htmlFor="to-date">To</label>

                    <Form.Control
                      id="to-date"
                      type="date"
                      value={toDate}
                      onChange={handleToDate}
                      min={fromDate || undefined}
                    />
                  </div>

                  {/* SEARCH BUTTON */}
                  <Button
                    type="button"
                    className="filter-btn search-btn"
                    onClick={loadOrders}
                    disabled={loading}
                  >
                    <i className="bi bi-search"></i>

                    <span>
                      {loading ? "Loading..." : "Search"}
                    </span>
                  </Button>

                  {/* CLEAR BUTTON */}
                  {(search || fromDate || toDate) && (
                    <Button
                      type="button"
                      className="filter-btn clear-btn"
                      onClick={handleClear}
                      disabled={loading}
                    >
                      <i className="bi bi-x-lg"></i>
                      <span>Clear</span>
                    </Button>
                  )}
                </div>


                {/* RIGHT: BULK ORDER */}
                <div className="header-right">
                  <Link
                    to="/account/orders/bulk-upload"
                    className="bulk-btn"
                  >
                    <i className="bi bi-upload"></i>
                    <span>Bulk Order</span>
                  </Link>
                </div>

              </div>
              {/* =================================================
                  TABLE
              ================================================= */}
              <div className="table-card-box">

                <DataTable
                  columns={columns}
                  data={filteredOrders}
                  customStyles={
                    customStyles
                  }
                  pagination
                  highlightOnHover
                  responsive
                  striped
                  progressPending={
                    loading
                  }
                  noDataComponent={
                    loading
                      ? "Loading orders..."
                      : "No orders found"
                  }
                />

              </div>
            </div>
          </Col>
        </Row>
      </div>

      {/* =======================================================
          WHATSAPP MODAL
      ======================================================= */}
      <Modal
        show={
          showWhatsappModal
        }
        onHide={
          handleCloseWhatsappModal
        }
        size="lg"
        className="whatsapp-order-modal"
        centered
      >

        {/* HEADER */}
        <Modal.Header closeButton>
          <Modal.Title>
            Send WhatsApp
          </Modal.Title>
        </Modal.Header>

        {/* BODY */}
        <Modal.Body className="p-0">

          <div className="whatsapp-send-table">
            {/* HEADER ROW */}
            <div className="whatsapp-send-row whatsapp-send-header">
              <div className="whatsapp-send-cell receiver-cell"> Receiver Name </div>
              <div className="whatsapp-send-cell mobile-cell"> Mobile No. </div>
              <div className="whatsapp-send-cell action-cell"> Action </div>
            </div>

            {/* DATA ROW */}
            {selectedOrder && (
              <div className="whatsapp-send-row">
                <div className="whatsapp-send-cell receiver-cell">
                  <span className="receiver-name">
                    {getCustomerName(
                      selectedOrder
                    )}
                  </span>
                </div>

                {/* MOBILE */}
                <div className="whatsapp-send-cell mobile-cell">
                  <input
                    type="text"
                    className="whatsapp-mobile-input"
                    value={
                      mobileNumber
                    }
                    placeholder="Enter Mobile No."
                    onChange={(e) => {
                      const value =
                        e.target.value.replace(
                          /\D/g,
                          ""
                        );

                      setMobileNumber(
                        value
                      );
                    }}
                    maxLength={10}
                    disabled={
                      whatsappLoading
                    }
                  />

                </div>

                {/* SEND */}
                <div className="whatsapp-send-cell action-cell">
                  <button
                    type="button"
                    className="whatsapp-send-btn"
                    onClick={
                      handleSendWhatsapp
                    }
                    disabled={
                      whatsappLoading
                    }
                  >
                    <i className="bi bi-whatsapp"></i>

                    <span>
                      {whatsappLoading
                        ? "Sending..."
                        : "Send"}
                    </span>
                  </button>

                </div>

              </div>
            )}

          </div>
        </Modal.Body>
      </Modal>
    </section>

       </>
  );
}
export default MyOrder;
